import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

import EntitlementActions from './entitlement-actions';

const initialState = Immutable({
  isLoading: false,
  byId:      {},
});

const reducer = createReducer(on => {
  on(EntitlementActions.fetchEntitlements, state => state.set('isLoading', true));

  // record the granted entitlements by experience and promotion id
  on(EntitlementActions.fetchEntitlementsSuccess, (state, { experienceId, promotionId, count }) => {
    return state.setIn(['byId', `${experienceId}:${promotionId}`], count).set('isLoading', false);
  });

  on(EntitlementActions.resetState, () => initialState);
}, initialState);

export default reducer;
